"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.prepareProductForDataLayer = exports.getListClasses = exports.getLength = exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var formatAsMKSPath = dataUtils.formatAsMKSPath;
var prepareProductForDataLayer = function prepareProductForDataLayer(product, currencyFormat) {
  if (product) {
    var clonedProduct = JSON.parse(JSON.stringify(product));
    if (clonedProduct.cta && clonedProduct.cta.url) {
      clonedProduct.cta.url = formatAsMKSPath(clonedProduct.cta.url);
    }
    if (clonedProduct.price) {
      clonedProduct.price.currency = currencyFormat;
    }
    return clonedProduct;
  }
  return product;
};
exports.prepareProductForDataLayer = prepareProductForDataLayer;
var getListClasses = function getListClasses(params) {
  var menuOpen = params.menuOpen,
    theme = params.theme,
    isLast = params.isLast,
    isMarginRight = params.isMarginRight;
  return _navigationHeader["default"].navBtnItem + " " + _navigationHeader["default"].baseBtnItem + " " + (menuOpen ? null : theme.grey) + " " + _navigationHeader["default"].subColumnWrap + " " + (isMarginRight ? _navigationHeader["default"].rightMargin : '') + " " + (isLast ? _navigationHeader["default"].lastBtnItem : '') + " menu-panel-top-level-item";
};
exports.getListClasses = getListClasses;
var getLength = function getLength(arr) {
  return arr && arr.length;
};
exports.getLength = getLength;
var roundClickHandler = function roundClickHandler(url, linkName) {
  if (window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'navclick',
      component: 'top_nav',
      action: 'nav_click',
      click_text: linkName,
      click_url: url
    });
  }
};
var BasicMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(BasicMenu, _React$Component);
  function BasicMenu(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var keyHandler = props.keyHandler || _this.keyHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.focusHandler = _this.focusHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.refList = {};
    _this.state = {
      keyHandler: keyHandler
    };
    _this.handleMouseDownToggle = _this.handleMouseDownToggle.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = BasicMenu.prototype;
  _proto.handleMouseDownToggle = function handleMouseDownToggle() {
    var _this$props = this.props,
      currentPath = _this$props.currentPath,
      products = _this$props.products,
      _this$props$config = _this$props.config,
      market = _this$props$config.market,
      currencyFormat = _this$props$config.currencyFormat,
      name = _this$props.name;
    if (market.toLowerCase() === 'mx' && typeof window !== 'undefined' && window.dataLayer && products && products.length > 0) {
      var productsClone = [];
      products.forEach(function (product) {
        productsClone.push(prepareProductForDataLayer(product, currencyFormat));
      });
      window.dataLayer.push({
        event: 'view_item_list',
        view_item_listdata: [{
          position: 'Header',
          items: productsClone.map(function (product) {
            return prepareProductForDataLayer(product, currencyFormat);
          }),
          item_list_name: name,
          layer: formatAsMKSPath(currentPath)
        }]
      });
    }
  };
  _proto.keyHandler = function keyHandler() {
    var keyHandlerMethod = this.props.keyHandlerMethod;
    keyHandlerMethod.apply(void 0, arguments);
  };
  _proto.focusHandler = function focusHandler() {
    var focusHandler = this.props.focusHandler;
    if (focusHandler !== undefined) {
      focusHandler(true);
    }
  };
  _proto.render = function render() {
    var _subNavigationItems$, _subNavigationItems$$, _subNavigationItems$2, _subNavigationItems$3, _subNavigationItems$4, _subNavigationItems$5, _subNavigationItems$0, _subNavigationItems$1;
    var _this$props2 = this.props,
      name = _this$props2.name,
      activeNav = _this$props2.activeNav,
      subNavigationcontainer = _this$props2.subNavigationcontainer,
      setSize = _this$props2.setSize,
      posInSet = _this$props2.posInSet,
      menuOpen = _this$props2.menuOpen,
      isLast = _this$props2.isLast,
      theme = _this$props2.theme,
      links = _this$props2.links,
      products = _this$props2.products,
      mobileNavActive = _this$props2.mobileNavActive; // eslint-disable-line
    var subNavigationItems = subNavigationcontainer.subNavigationItems,
      promoterDetails = subNavigationcontainer.promoterDetails;
    var id = name.toLowerCase();
    var linkSetSize = getLength(links) ? links.length : 0;
    var productSetSize = getLength(products) ? products.length : 0;
    var totalSetSize = linkSetSize + productSetSize;
    var expanded = activeNav === id && menuOpen && !mobileNavActive;
    var hasPopUp = !!(linkSetSize || productSetSize);
    var reducedHeight = !(links.length > 0 && products.length === 0);
    var isMarginRight = ((_subNavigationItems$ = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$$ = _subNavigationItems$.links[0]) == null ? void 0 : _subNavigationItems$$.backgroundCTA) === 'white';
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: getListClasses({
        menuOpen: menuOpen,
        theme: theme,
        isLast: isLast,
        isMarginRight: isMarginRight
      }),
      role: "menuitem",
      "aria-expanded": expanded,
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "aria-haspopup": hasPopUp,
      "data-menu-item-name": name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"][(_subNavigationItems$2 = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$3 = _subNavigationItems$2.links[0]) == null ? void 0 : _subNavigationItems$3.backgroundCTA] + " " + _navigationHeader["default"].roundLinks,
      href: (_subNavigationItems$4 = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$5 = _subNavigationItems$4.links[0]) == null ? void 0 : _subNavigationItems$5.url,
      onClick: function onClick() {
        var _subNavigationItems$6, _subNavigationItems$7, _subNavigationItems$8, _subNavigationItems$9;
        return roundClickHandler((_subNavigationItems$6 = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$7 = _subNavigationItems$6.links[0]) == null ? void 0 : _subNavigationItems$7.url, (_subNavigationItems$8 = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$9 = _subNavigationItems$8.links[0]) == null ? void 0 : _subNavigationItems$9.label);
      }
    }, (_subNavigationItems$0 = subNavigationItems[0]) == null ? void 0 : (_subNavigationItems$1 = _subNavigationItems$0.links[0]) == null ? void 0 : _subNavigationItems$1.label));
  };
  return BasicMenu;
}(_react["default"].Component);
BasicMenu.displayName = 'BasicMenu';
BasicMenu.defaultProps = {
  links: [],
  products: []
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    config: state.Config
  };
};
var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(BasicMenu);
exports["default"] = _default;